import { render, staticRenderFns } from "./ExportationsCompanyStatus.vue?vue&type=template&id=4d23936e&scoped=true&"
import script from "./ExportationsCompanyStatus.vue?vue&type=script&lang=ts&"
export * from "./ExportationsCompanyStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d23936e",
  null
  
)

export default component.exports